import { createFileRoute } from '@tanstack/react-router';
import { ResponsesSummary } from '@/app/(client)/questionnaires/-components/ResponsesSummary';

export const Route = createFileRoute(
  '/(client)/questionnaires/(pages)/(detail)/$id/summary/',
)({
  component: ResponsesSummaryRoute,
});

function ResponsesSummaryRoute() {
  const { id } = Route.useParams();
  return (
    <div className='flex flex-col flex-1 min-w-0 min-h-0 overflow-y-auto'>
      <ResponsesSummary questionnaireId={id} />
    </div>
  );
}
